import React, {Component,} from 'react'

import PropTypes from 'prop-types'
import CCActivityIndicator from "../CCActivityIndicator/CCActivityIndicator";

import {strings} from "./../../cc-imports";
// import './cc-section-list.css'
import './../../styles/css/components/CCSectionList/cc-section-list.css'


class CCSectionList extends Component {

    static propTypes = {
        refreshing: PropTypes.bool,
        onRefresh: PropTypes.bool,
        onEndReached: PropTypes.func,
        onEndReachedThreshold: PropTypes.number,
        ListEmptyComponent: PropTypes.component,
        renderSectionHeader: PropTypes.func,
        renderItem: PropTypes.func,
        ListFooterComponent: PropTypes.component,
        endReached: PropTypes.bool,
        sections: PropTypes.array,
        ListEndComponent: PropTypes.component,
        scrollClassName : PropTypes.string
    }

    static defaultProps = {
        refreshing: false,
        onRefresh: () => {
        },
        onEndReached: () => {
        },
        onEndReachedThreshold: 1,
        sections: [],
        ListEmptyComponent: undefined,
        renderItem: () => {
        },
        ListFooterComponent: undefined,
        endReached: false,
        ListEndComponent: undefined,
        scrollClassName : ''
    }

    constructor(props) {
        super(props)
        this.state = {}
        //this._onShow=this._onShow.bind(this);
        this.trackScrolling = this.trackScrolling.bind(this);
        this.isBottom = this.isBottom.bind(this);
    }

    /*_onShow(length, endThreshold, index) {
        console.log(length,endThreshold,index);
        console.log("------------------------------------------")
        if(length-1-endThreshold==index){
            this.props.onEndReached();
        }
    }*/


    trackScrolling = () => {
        const {data, onEndReached} = this.props;

        const parent = document.getElementById('listViewParent');
        const child = document.getElementById('cc_footer');
        if (this.isBottom(parent, child)) {
            console.log('header bottom reached');
            onEndReached();
        }
    };

    componentDidMount() {
        //document.addEventListener('scroll', this.trackScrolling);
    }

    isBottom(parent, el) {
        return el.getBoundingClientRect().bottom <= parent.getBoundingClientRect().bottom;
    }

    render() {
        const {refreshing, onRefresh, onEndReached, onEndReachedThreshold,scrollClassName, sections, ListEmptyComponent, renderItem, renderSectionHeader, ListFooterComponent, endReached, ListEndComponent} = this.props;

        return (
            <div className="flex-container section-container" id={'listViewParent'}
                 style={{ ...this.props.style}}
                 onScroll={this.trackScrolling}>
                {
                    sections.length > 0 ?
                        <div className={"scroll vertical "+scrollClassName}>
                            {
                                sections.map((section, index) => {
                                    return (
                                        <div>
                                            {renderSectionHeader(section, index)}
                                            {
                                                (section && section.data) &&
                                                    <div>
                                                        {
                                                            section.data.map((item, index) => {
                                                                return (<div>
                                                                    {
                                                                        renderItem(item)
                                                                    }
                                                                </div>)
                                                            })
                                                        }
                                                    </div>
                                            }
                                        </div>)
                                })
                            }
                            {
                                <div className={'flex-container section-container'}
                                      id={"cc_footer"}>
                                    {
                                        endReached ?  ListEndComponent ? ListEndComponent : <h3 className={'section-list-eor'}>{strings('end_of_results2')}</h3>

                                            :
                                            <CCActivityIndicator size={'s'}/>

                                    }
                                </div>
                            }
                        </div>
                        :
                        ListEmptyComponent
                }
            </div>
        )
    }
}

export default CCSectionList



// WEBPACK FOOTER //
// ./src/app/components/CCSectionList/CCSectionList.js